import Vue from 'vue'
import HoverIntent from 'vue2-hover-intent'

// DOCS: https://github.com/gabrieliuga/vue2-hover-intent
Vue.directive('hover-intent', HoverIntent)
